"use strict";

exports.__esModule = true;
exports.ErrorMessageWrapperDataHooks = void 0;
let ErrorMessageWrapperDataHooks = /*#__PURE__*/function (ErrorMessageWrapperDataHooks) {
  ErrorMessageWrapperDataHooks["Message"] = "errormessagewrapper-message";
  return ErrorMessageWrapperDataHooks;
}({});
exports.ErrorMessageWrapperDataHooks = ErrorMessageWrapperDataHooks;
//# sourceMappingURL=types.js.map